import { api } from './http';
import type {
  CoClientMatter,
  Contact,
  ContactFilterOptions,
  ContactListResponse,
  DuplicateCheckResult,
} from './types';

export const getContacts = (params?: {
  search?: string;
  source?: string;
  state?: string;
  has_email?: boolean;
  has_phone?: boolean;
  created_from?: string;
  created_to?: string;
  sort_by?: string;
  sort_dir?: string;
  limit?: number;
  offset?: number;
}) => api.get<ContactListResponse>('/contacts', { params }).then(r => r.data);

export const getContactFilterOptions = () =>
  api.get<ContactFilterOptions>('/contacts/filter-options').then(r => r.data);

export const getContact = (id: number) =>
  api.get<Contact>(`/contacts/${id}`).then(r => r.data);

export const createContact = (data: Partial<Contact>) =>
  api.post<Contact>('/contacts', data).then(r => r.data);

export const updateContact = (id: number, data: Partial<Contact>) =>
  api.patch<Contact>(`/contacts/${id}`, data).then(r => r.data);

export const checkContactDuplicates = (params: { first_name: string; last_name: string; email?: string; phone?: string }) =>
  api.get<DuplicateCheckResult>('/contacts/duplicate-check', { params }).then(r => r.data);

export const getContactCoClientMatters = (contactId: number) =>
  api.get<CoClientMatter[]>(`/contacts/${contactId}/co-client-matters`).then(r => r.data);

export const setContactSsn = (id: number, ssn: string) =>
  api.put<Contact>(`/contacts/${id}/ssn`, { ssn }).then(r => r.data);

export const clearContactSsn = (id: number) =>
  api.delete<Contact>(`/contacts/${id}/ssn`).then(r => r.data);

export const revealContactSsn = (id: number) =>
  api.post<{ ssn: string | null }>(`/contacts/${id}/ssn/reveal`).then(r => r.data);
